export const translatedPathnameDocsQuery = groq`*[_type=='translatedPathnames']`;
